<sof-app-shell
  class="layout-shell"
  [logo]="logoFull"
  [logoSmall]="logoSmall"
  textFooter="© 2026 Softion"
>
  <router-outlet></router-outlet>
</sof-app-shell>
